import React, { useEffect, useState } from 'react'
import { useGetTopSectionQuery, useTopSectionMutation } from '../../../services/Api';
import { toast } from 'react-toastify';
import LoaderSpiner from '../../../components/loaderSpiner';

const TopSections = () => {
    const { data, isLoading } = useGetTopSectionQuery();
    const [topSection] = useTopSectionMutation();

    const [inputValue, setInputValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    // Helper to safely get the title
    const getTitle = () => {
        if (Array.isArray(data) && data.length > 0 && data[0]?.title) {
            return data[0].title;
        }
        return "";
    };

    useEffect(() => {
        setInputValue(getTitle());
    }, [data]);

    const handleUpdate = async () => {
        const formData = {
            title: inputValue,
        };
        topSection({ data: formData })
            .unwrap()
            .then((payload) => {

                toast.success("Banner Added Successfully");
                setIsEditing(false);

            })
            .catch((error) => {
                toast.error(error?.data?.message || "An error occurred");
            });

    };

    if (isLoading) return <LoaderSpiner />;

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-4xl font-bold text-center">Top Section</h1>

            {/* Banner */}
            <div className="bg-dark text-center py-3 rounded-md">
                <p
                    className="italic font-bold font-roboto-mono capitalize text-sm text-white"
                    dangerouslySetInnerHTML={{ __html: inputValue }}
                />
            </div>

            {/* Editor */}
            {isEditing ? (
                <div className="space-y-4">
                    <textarea
                        rows={4}
                        className="w-full p-3 border border-gray-300 rounded-md text-sm font-mono"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                    <div className="flex gap-2">
                        <button
                            onClick={handleUpdate}
                            className="bg-bgprimary rounded-xl text-dark px-6 py-3 font-quicksand font-bold"
                        >
                            Update Message
                        </button>
                        <button
                            onClick={() => {
                                setInputValue(getTitle());
                                setIsEditing(false);
                            }}
                            className="bg-bgprimary rounded-xl text-dark px-6 py-3 font-quicksand font-bold"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ) : (
                <button
                    onClick={() => setIsEditing(true)}
                    className="bg-bgprimary rounded-xl text-dark px-6 py-3 font-quicksand font-bold"
                >
                    Edit Top Section Message
                </button>
            )}
        </div>
    );
}

export default TopSections
